(function () {
    'use strict';

    /**
     * Counter (count down to the event) section - owns its data.
     * Used as an attribute on the server rendered <section> (Views/Events/_Counter.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "counterSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionCounter', sectionCounter);

    function sectionCounter() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionCounterCtrl,
            controllerAs: 'counterSection'
        };
    }

    SectionCounterCtrl.$inject = ['$element', 'SectionRegistry'];

    function SectionCounterCtrl($element, SectionRegistry) {
        const vm = this;
        // null until loaded - the countdown is shown (ng-if) only once it is set
        vm.counter = null;

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Start the count down - no api call, uses the event date from the page
         * @param {number} eventId
         * @param {number} lang
         * @param {object} pageData { date, offset } the event start date and time zone offset
         */
        function load(eventId, lang, pageData) {
            vm.counter = {
                date: pageData.date,
                offset: pageData.offset,
                refresh: 1000,
            };
        }
    }
})();
